// extracted by mini-css-extract-plugin
export default {"heading":"TermsOfServicePage_heading__4rqPb h1","content":"TermsOfServicePage_content__mW7Ht"};